var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "previous button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "control-bar/videos-and-images",
    transform: "translate(-102.000000, -38.000000)",
    fill: "#5C7284",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video-play",
    transform: "translate(99.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75,59 C6.359375,59 6.859375,58.78125 7.5,58.421875 L24.796875,48.40625 C26.046875,47.6875 26.5,47.171875 26.5,46.34375 C26.5,45.515625 26.046875,45 24.796875,44.28125 L7.5,34.265625 C6.859375,33.90625 6.359375,33.6875 5.75,33.6875 C4.625,33.6875 3.875,34.546875 3.875,35.890625 L3.875,56.796875 C3.875,58.140625 4.625,59 5.75,59 Z",
    id: "previous-button",
    transform: "translate(15.187500, 46.343750) scale(-1, 1) translate(-15.187500, -46.343750) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.2d1aac39.svg";
export { ForwardRef as ReactComponent };